import { render } from "./PendingIcon.vue?vue&type=template&id=0f7cb04e"
const script = {}

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__